/* -------------------------------------------------------------------------- */
/*                       Change Logo Dimensions                               */
/* -------------------------------------------------------------------------- */

const changeLogoDimensions = () => {
  let maxWidth = 300;
  let maxHeight = 280;
  let maxAspectRatio = maxWidth / maxHeight;
  let myImage = new Image();
  const tenantLogo = document.querySelector('.horizontal-header-logo');
  if (tenantLogo) {

    let radioBtn = document.querySelectorAll('input[name="logoPosition"]');
    radioBtn.forEach((elem) => {
      elem.addEventListener("change", () => {
        
        
        if (document.querySelector("input[name='logoPosition']:checked")) {
          let radioBtnVal = document.querySelector("input[name='logoPosition']:checked").value;
          if(radioBtnVal === "vertical") {
            myImage.src = tenantLogo.dataset.vsrc;
          } else {
            myImage.src= tenantLogo.dataset.hsrc;
          }

          myImage.onload = () => {
            let myImageAspectRatio = myImage.naturalWidth / myImage.naturalHeight;
            if(myImageAspectRatio > maxAspectRatio) {
              tenantLogo.setAttribute("width", maxWidth > myImage.naturalWidth ? myImage.naturalWidth : maxWidth);
              tenantLogo.removeAttribute("height");
            } else {
              tenantLogo.setAttribute("height", maxHeight > myImage.naturalHeight ? myImage.naturalHeight : maxHeight); 
              tenantLogo.removeAttribute("width");
            }
            tenantLogo.src = myImage.src;
          }

        }      
      });
    })
  }






  let defaultMock = window.localStorage.getItem('enableMock');
  let radioBtn = document.querySelectorAll('input[name="enableMock"]');
  for (let i=0; i < radioBtn.length; i=i+1) {
    if (radioBtn[i].value === defaultMock) { 
      radioBtn[i].checked = true;
    }
  }
  radioBtn.forEach((elem) => {
    elem.addEventListener("change", () => {
      if (document.querySelector("input[name='enableMock']:checked")) {
        let radioBtnVal = document.querySelector("input[name='enableMock']:checked").value;
        window.localStorage.setItem('enableMock', radioBtnVal);
      }
    });
  })


}

export default changeLogoDimensions;